const Success = () => {
  return <></>;
};

export default Success;
